import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'duration',
  standalone: true,
  pure: false // Set to false to make reactive when language changes
})
export class DurationPipe implements PipeTransform {
  public _translateService = inject(TranslateService);
  
  transform(minutes: number): string {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;

    const parts: string[] = [];

    if (h > 0) {
      const hourLabel = this._translateService.instant(h === 1 ? 'hora' : 'horas');
      parts.push(`${h} ${hourLabel}`);
    }

    if (m > 0) {
      const minuteLabel = this._translateService.instant(m === 1 ? 'minuto' : 'minutos');
      parts.push(`${m} ${minuteLabel}`);
    }

    return parts.join(' ');
  }
}
